var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floatlogin"},[_c('el-row',[_c('a',{attrs:{"href":"/activity","target":"_blank"}},[_c('img',{attrs:{"src":"/images/advertisement.png","width":"100%"}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }